import createReactComponent from '../createReactComponent';
export default createReactComponent('move-vertical', 'MoveVertical', [["path",{"d":"m8 18 4 4m0 0 4-4m-4 4V2M8 6l4-4m0 0 4 4","key":"svg-0"}]]);